import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ProductCoAModal,
  ProductChainDetails,
  RecentBatchesListing,
  RecentBatchesListingQueryParameters,
} from "./types";

const initialState: ProductCoAModal = {
  productChainDetails: {
    sampleImage: "",
    growerNote: "",
    coaPdfIpfsHash: "",
    coaRawIpfsHash: "",
    metaDataIpfsHash: "",
    coaNftIpfsHash: "",
    strainType: "",
    strainName: "",
    productImage: "",
    climsId: "",
    manufacturerInfo: {
      name: "",
      companyName: "",
      companyPicture: "",
    },
    blockchainInfo: {
      tokenStandard: "",
      chainName: "",
      contractAddress: "",
      tokenId: "",
      contractAddressRedirectUrl: "",
      tokenIdRedirectUrl: "",
      transactionHash: "",
      productNftMetadataIpfsUrl: "",
      regulatorBatchId: "",
    },
    primaryInfo: {
      strainName: "",
      strainMongoId: "",
      coaId: "",
      batchIndexId: "",
      productType: "",
      productSubType: "",
      cultivationState: "",
      cultivatorName: "",
      // totalProductCount: "",
      harvestDate: "",
      packageDate: "",
      manufacturedDate: "",
      productTokenizedAt: "",
      batchId: "",
    },
    keyComponents: {
      thcTotal: "",
      cbdTotal: "",
      cannabinoidTotal: "",
      topThreeCannabinoids: [],
      topThreeTerpenes: [],
      terpeneTotal: "",
    },
    maxThcMg: "",
    maxCbdMg: "",
    maxThcWeight: "",
    dataPlatform: "",
    maxCbdWeight: "",
    totalTerpenesMg: "",
    totalCannabinoidsMg: "",
    totalCannabinoidsWeight: "",
    totalTerpenesPercentWeight: "",
    coaPdfUrl: "",
  },

  CoABatchesListing: {
    data: [],
    total: 0,
    limit: 10,
    pageNo: 1,
    nextHit: 0,
    totalPage: 0,
  },

  hasMoreBatches: false,

  recentBatchesListingQueryParameters: {
    pageNo: 1,
    limit: 5,
    sortBy: 0,
    sortCrietria: "myCollection",
  },

  loading: false,
  error: null,
};

const productCoASlice = createSlice({
  name: "productCoASlice",
  initialState,
  reducers: {
    setCoALoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setCoAError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    setProductCoADetails(state, action: PayloadAction<ProductChainDetails>) {
      state.productChainDetails = action.payload;
    },

    resetCoAState(state) {
      state.productChainDetails = initialState.productChainDetails;
      state.loading = false;
      state.error = null;
    },

    setCoABatchesListing(state, action: PayloadAction<RecentBatchesListing>) {
      const newPayload = action.payload;

      state.CoABatchesListing = {
        ...newPayload,
        data: [...state.CoABatchesListing.data, ...newPayload.data],
      };

      state.hasMoreBatches = newPayload.totalPage > newPayload.pageNo;
    },

    setResetCoABatchesListing(state) {
      state.CoABatchesListing = {
        data: [],
        total: 0,
        limit: 10,
        pageNo: 1,
        nextHit: 0,
        totalPage: 0,
      };

      state.hasMoreBatches = false;
      state.loading = false;
    },

    setRecentBatchesListingQueryParameters(
      state,
      action: PayloadAction<RecentBatchesListingQueryParameters>,
    ) {
      state.recentBatchesListingQueryParameters = { ...action.payload };
    },
  },
});

export const {
  setCoALoading,
  setCoAError,
  setProductCoADetails,
  resetCoAState,
  setCoABatchesListing,
  setResetCoABatchesListing,
  setRecentBatchesListingQueryParameters,
} = productCoASlice.actions;

export default productCoASlice.reducer;
